import DOMPurify from 'dompurify';

export const useSanitize = () => {
  const containsMarkdown = (part: string) => {
    return part.includes('```');
  };

  const containsHTMLTags = (part: string) => {
    const HTMLRegex = /<[^>]*>/;

    return HTMLRegex.test(part);
  };

  const sanitize = (part: string) => {
    return DOMPurify.sanitize(part, {
      USE_PROFILES: { html: true },
      FORBID_TAGS: [
        'form',
        'input',
        'textarea',
        'button',
        'select',
        'fieldset',
        'legend',
        'datalist',
        'output',
        'option',
        'optgroup',
        'a',
        'script',
        'meta',
        'style',
        'iframe',
        'embed',
        'object',
        'link',
        'audio',
        'video',
        'img',
        'base',
        'svg',
        'math',
        'applet',
        'frameset',
        'frame',
        'marquee',
      ],
      KEEP_CONTENT: false,
      FORBID_ATTR: [
        'style',
        'onerror',
        'onload',
        'onchange',
        'onsubmit',
        'onreset',
        'onselect',
        'onblur',
        'onfocus',
        'onkeydown',
        'onkeypress',
        'onkeyup',
        'onmousedown',
        'onmousemove',
        'onmouseout',
        'onmouseover',
        'onmouseup',
        'ondblclick',
        'oncontextmenu',
        'onwheel',
        'oncopy',
        'oncut',
        'onpaste',
        'onabort',
        'onbeforeunload',
        'onerror',
        'onhashchange',
        'onload',
        'onpageshow',
        'onpagehide',
        'onresize',
        'onscroll',
        'src',
        'href',
        'action',
      ],
    });
  };

  const extractHTML = (input: string) => {
    const htmlRegex = /(<[^>]+>[\s\S]*<\/[^>]+>)/gi;

    // Match the first complete HTML block
    const match = htmlRegex.exec(input);

    if (match) {
      const [before, after] = input.split(match[0]).map((str) => str.trim());
      return [before, match[0].trim(), after];
    }

    // If no HTML is found, return the original input as a single chunk
    return [input, '', ''];
  };

  const extractMarkdown = (input: string) => {
    const markdownRegex = /```html([\s\S]*?)```|```([\s\S]*?)```/gi;
    const match = markdownRegex.exec(input);

    if (match) {
      const content = match[1] || match[2];
      const [before, after] = input.split(match[0]).map((str) => str.trim());
      return [before, content.trim(), after];
    }

    // If no Markdown is found, fallback to HTML extraction
    return extractHTML(input);
  };

  return {
    sanitize,
    containsMarkdown,
    containsHTMLTags,
    extractMarkdown,
  };
};
